import { View, Text } from '@react-pdf/renderer';
import { pdfStyles } from '../styles';

/**
 * Компонент для рендеринга ячейки PDF-таблицы
 * @param {Object} props
 * @param {string|number} props.text - Текст для отображения
 * @param {string|Array} props.cellStyle - Стиль для внешнего View (например, pdfStyles.tableCol10)
 * @param {string|Array} props.textStyle - Стиль для Text компонента
 * @param {boolean} props.hasNumber - Есть ли номер для применения стилей (для stylesCheckCell)
 * @param {Function} props.stylesCheckCell - Функция для проверки стилей на основе номера
 */
const PdfTableCell = ({ 
  text, 
  cellStyle, 
  textStyle, 
  hasNumber, 
  stylesCheckCell,
  innerStyle
}) => {
  const finalTextStyle = stylesCheckCell && hasNumber !== undefined 
    ? stylesCheckCell(hasNumber) 
    : textStyle || pdfStyles.ml3;

  const defaultInnerStyle = [pdfStyles.tableCol, pdfStyles.centerFlex];
  const finalInnerStyle = innerStyle !== undefined ? innerStyle : defaultInnerStyle;

  return (
    <View style={cellStyle}>
      {finalInnerStyle.length > 0 ? (
        <View style={finalInnerStyle}>
          <Text style={finalTextStyle}>{text}</Text>
        </View>
      ) : (
        <Text style={finalTextStyle}>{text}</Text>
      )}
    </View>
  );
};

export default PdfTableCell;

